import React from 'react';

/*
 * HowItWorks — the four-step "From scroll to script to voiceover" section,
 * pulled out of the old bottom block so it can stand on its own between the
 * Transcriber and the new toolkit sections. Copy + styling unchanged.
 */
const HowItWorks = () => (
  <section className="border-t border-[#EFE8DD] bg-[#FFFDF9]" id="how-it-works" data-testid="home-how-it-works">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-10">
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-[-0.02em] text-[#1F1B16]">
          From scroll to script <span className="italic text-[#1E7A6B]">to voiceover.</span>
        </h2>
        <p className="text-[#6F675D] max-w-xs lg:text-right">
          No blank page. Start from something that&rsquo;s already proven to sell, and make it yours.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
        {[
          ['Paste a winning video', 'Any TikTok or Instagram video that&rsquo;s already moving product in your niche.'],
          ['See why it works', 'Poettik pulls the transcript and breaks down the hook, pacing, tone and persuasion.'],
          ['Get your script', 'Same winning structure, rewritten for your product in UGC, authority or negative style.'],
          ['Turn it into a voiceover', 'Generate a voiceover from your script, ready to drop under your footage.'],
        ].map(([t, d], i) => (
          <div key={t} className="rounded-2xl bg-white border border-[#EAE3D8] p-6">
            <div className="font-display italic text-[#9D174D] text-4xl leading-none mb-4">{i + 1}</div>
            <h3 className="font-display text-lg mb-2 text-[#1F1B16]">{t}</h3>
            <p className="text-sm text-[#6F675D] leading-relaxed" dangerouslySetInnerHTML={{ __html: d }} />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
